const { CrossStorageHub } = require('cross-storage');

if (!process.env.CLIENTS) {
  throw new Error('Hub client whitelist not found');
}

const clients = JSON.parse(process.env.CLIENTS);
if (!Array.isArray(clients) || !clients.length) {
  throw new Error('Hub client whitelist non-array or empty');
}

console.log('last: ', clients[clients.length - 1]);
// TODO (KC): Remove after cache-invalidation testing is complete (see DVOP-5288)

const clientPermissions = clients.map((client) => {
  return {
    origin: new RegExp(`^${client.replace(/\./g, '\\.')}$`, 'i'),
    allow: ['get', 'set', 'del', 'getKeys', 'clear'],
  };
});

CrossStorageHub.init(clientPermissions);
